export default {
    ACTIVE_MENU_ITEM: 'SETTING.ACTIVE_MENU_ITEM',
};
